export class StorageService {

    constructor() {
    }

    get<T>(key: string): any {
        return <T>JSON.parse(window.localStorage.getItem(key));
    }

    set<T>(key: string, data: T): void {
        window.localStorage.setItem(key, JSON.stringify(data));
    }

    remove(key: string) {
        window.localStorage.removeItem(key);
    }
}